module.exports = __webpack_public_path__ + "img/international.384a1ed4.png";